// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_lJx","cls2":"UserCard-cls2_j80 UserCard-cls1_lJx"};